.title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 12px;
}

.text {
  font-size: 16px;
  color: #555;
  max-width: 300px;
  margin: 0 auto;
}